import { ContactClass } from 'app/utility/enums';
import { Component, OnInit, Input } from '@angular/core';
import { ContactResultModel } from 'app/models/dms/contact.model';
import { ContactService } from 'app/services/contact.service';

@Component({
    selector: 'app-contact-image-displayer',
    templateUrl: './contact-image-displayer.component.html',
    styleUrls: ['./contact-image-displayer.component.scss'],
    standalone: false
})
export class ContactImageDisplayerComponent implements OnInit {
    @Input() contact: ContactResultModel;
    @Input() initials: string;
    @Input() summary: boolean = false;
    @Input() height: number = 40;
    @Input() width: number = 40;
    @Input() borderRadius: number = 5; //this.height;

    @Input() paddingTop: number = 0;

    hasImage: boolean = false;

    constructor(private contactService: ContactService) { }

    ngOnInit() {
        this.setInitials();
        this.setClass();
    }

    setInitials(): void {
        if (this.initials) {
            // return this.initials;
        }
        if (this.contact) {
            this.initials = this.contactService.getContactInitials(this.contact);
        }
    }

    class: string;
    setClass(): void {
        var c = this.getContactColourClass();
        if (this.contact) {
            if (this.contact.contactClass==ContactClass.Business) {
                c += ' business';
            }
        }
        this.class = c+' contact-image size-'+this.width;
    }

    private getContactColourClass()
    {
        if (this.contact)
        {
            return this.contactService.getContactColourClass(this.contact);
        }
        else if (this.initials && this.initials.length>0)
        {
            return 'contact-class-' + this.initials[0].toLowerCase();
        }
    }

}
